/**
 * Smartfactor API
 * API for Smartfactor System
 *
 * The version of the OpenAPI document: 0.4.424
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { RoadOccupationStagePurposeFeeAppEntityRoadOccupationStagePurposeFeeItemRead } from '../model/roadOccupationStagePurposeFeeAppEntityRoadOccupationStagePurposeFeeItemRead';
// @ts-ignore
import { RoadOccupationStagePurposeFeeAppEntityRoadOccupationStagePurposeFeeRead } from '../model/roadOccupationStagePurposeFeeAppEntityRoadOccupationStagePurposeFeeRead';
// @ts-ignore
import { RoadOccupationStagePurposeFeeAppEntityRoadOccupationStagePurposeFeeWrite } from '../model/roadOccupationStagePurposeFeeAppEntityRoadOccupationStagePurposeFeeWrite';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


export interface DeleteRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeItemRequestParams {
    id: string;
}

export interface GetRoadOccupationStagePurposeFeeCollectionRoadOccupationStagePurposeFeeCollectionRequestParams {
    stage?: string;
    stage2?: Array<string>;
    stageId?: string;
    stageId2?: Array<string>;
    purposeFee?: string;
    purposeFee2?: Array<string>;
    purposeFeeId?: string;
    purposeFeeId2?: Array<string>;
    orderOrdinalNumber?: string;
    /** The collection page number */
    page?: number;
    /** The number of items per page */
    itemsPerPage?: number;
    /** Enable or disable pagination */
    pagination?: boolean;
}

export interface GetRoadOccupationStagePurposeFeeItemRoadOccupationStagePurposeFeeItemRequestParams {
    id: string;
}

export interface PatchRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeItemRequestParams {
    id: string;
    /** The updated RoadOccupationStagePurposeFee resource */
    roadOccupationStagePurposeFee?: RoadOccupationStagePurposeFeeAppEntityRoadOccupationStagePurposeFeeWrite;
}

export interface PostRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeCollectionRequestParams {
    /** The new RoadOccupationStagePurposeFee resource */
    roadOccupationStagePurposeFee?: RoadOccupationStagePurposeFeeAppEntityRoadOccupationStagePurposeFeeWrite;
}


@Injectable({
  providedIn: 'root'
})
export class RoadOccupationStagePurposeFeeService {

    protected basePath = '/system';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
            if (firstBasePath != undefined) {
                basePath = firstBasePath;
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Removes the RoadOccupationStagePurposeFee resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeItem(requestParameters?: DeleteRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeItemRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public deleteRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeItem(requestParameters?: DeleteRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeItemRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public deleteRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeItem(requestParameters?: DeleteRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeItemRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public deleteRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeItem(requestParameters?: DeleteRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeItemRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeItem.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road_occupation_stage_purpose_fees/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves the collection of RoadOccupationStagePurposeFee resources.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRoadOccupationStagePurposeFeeCollectionRoadOccupationStagePurposeFeeCollection(requestParameters?: GetRoadOccupationStagePurposeFeeCollectionRoadOccupationStagePurposeFeeCollectionRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<Array<RoadOccupationStagePurposeFeeAppEntityRoadOccupationStagePurposeFeeRead>>;
    public getRoadOccupationStagePurposeFeeCollectionRoadOccupationStagePurposeFeeCollection(requestParameters?: GetRoadOccupationStagePurposeFeeCollectionRoadOccupationStagePurposeFeeCollectionRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<Array<RoadOccupationStagePurposeFeeAppEntityRoadOccupationStagePurposeFeeRead>>>;
    public getRoadOccupationStagePurposeFeeCollectionRoadOccupationStagePurposeFeeCollection(requestParameters?: GetRoadOccupationStagePurposeFeeCollectionRoadOccupationStagePurposeFeeCollectionRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<Array<RoadOccupationStagePurposeFeeAppEntityRoadOccupationStagePurposeFeeRead>>>;
    public getRoadOccupationStagePurposeFeeCollectionRoadOccupationStagePurposeFeeCollection(requestParameters?: GetRoadOccupationStagePurposeFeeCollectionRoadOccupationStagePurposeFeeCollectionRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const stage = requestParameters?.stage;
        const stage2 = requestParameters?.stage2;
        const stageId = requestParameters?.stageId;
        const stageId2 = requestParameters?.stageId2;
        const purposeFee = requestParameters?.purposeFee;
        const purposeFee2 = requestParameters?.purposeFee2;
        const purposeFeeId = requestParameters?.purposeFeeId;
        const purposeFeeId2 = requestParameters?.purposeFeeId2;
        const orderOrdinalNumber = requestParameters?.orderOrdinalNumber;
        const page = requestParameters?.page;
        const itemsPerPage = requestParameters?.itemsPerPage;
        const pagination = requestParameters?.pagination;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (stage !== undefined && stage !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>stage, 'stage');
        }
        if (stage2) {
            stage2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'stage[]');
            })
        }
        if (stageId !== undefined && stageId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>stageId, 'stage.id');
        }
        if (stageId2) {
            stageId2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'stage.id[]');
            })
        }
        if (purposeFee !== undefined && purposeFee !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>purposeFee, 'purposeFee');
        }
        if (purposeFee2) {
            purposeFee2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'purposeFee[]');
            })
        }
        if (purposeFeeId !== undefined && purposeFeeId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>purposeFeeId, 'purposeFee.id');
        }
        if (purposeFeeId2) {
            purposeFeeId2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'purposeFee.id[]');
            })
        }
        if (orderOrdinalNumber !== undefined && orderOrdinalNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>orderOrdinalNumber, 'order[ordinalNumber]');
        }
        if (page !== undefined && page !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>page, 'page');
        }
        if (itemsPerPage !== undefined && itemsPerPage !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>itemsPerPage, 'itemsPerPage');
        }
        if (pagination !== undefined && pagination !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pagination, 'pagination');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road_occupation_stage_purpose_fees`;
        return this.httpClient.request<Array<RoadOccupationStagePurposeFeeAppEntityRoadOccupationStagePurposeFeeRead>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves a RoadOccupationStagePurposeFee resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRoadOccupationStagePurposeFeeItemRoadOccupationStagePurposeFeeItem(requestParameters?: GetRoadOccupationStagePurposeFeeItemRoadOccupationStagePurposeFeeItemRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<RoadOccupationStagePurposeFeeAppEntityRoadOccupationStagePurposeFeeItemRead>;
    public getRoadOccupationStagePurposeFeeItemRoadOccupationStagePurposeFeeItem(requestParameters?: GetRoadOccupationStagePurposeFeeItemRoadOccupationStagePurposeFeeItemRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<RoadOccupationStagePurposeFeeAppEntityRoadOccupationStagePurposeFeeItemRead>>;
    public getRoadOccupationStagePurposeFeeItemRoadOccupationStagePurposeFeeItem(requestParameters?: GetRoadOccupationStagePurposeFeeItemRoadOccupationStagePurposeFeeItemRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<RoadOccupationStagePurposeFeeAppEntityRoadOccupationStagePurposeFeeItemRead>>;
    public getRoadOccupationStagePurposeFeeItemRoadOccupationStagePurposeFeeItem(requestParameters?: GetRoadOccupationStagePurposeFeeItemRoadOccupationStagePurposeFeeItemRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getRoadOccupationStagePurposeFeeItemRoadOccupationStagePurposeFeeItem.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road_occupation_stage_purpose_fees/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<RoadOccupationStagePurposeFeeAppEntityRoadOccupationStagePurposeFeeItemRead>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates the RoadOccupationStagePurposeFee resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeItem(requestParameters?: PatchRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeItemRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<RoadOccupationStagePurposeFeeAppEntityRoadOccupationStagePurposeFeeRead>;
    public patchRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeItem(requestParameters?: PatchRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeItemRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<RoadOccupationStagePurposeFeeAppEntityRoadOccupationStagePurposeFeeRead>>;
    public patchRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeItem(requestParameters?: PatchRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeItemRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<RoadOccupationStagePurposeFeeAppEntityRoadOccupationStagePurposeFeeRead>>;
    public patchRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeItem(requestParameters?: PatchRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeItemRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling patchRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeItem.');
        }
        const roadOccupationStagePurposeFee = requestParameters?.roadOccupationStagePurposeFee;

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/merge-patch+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road_occupation_stage_purpose_fees/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<RoadOccupationStagePurposeFeeAppEntityRoadOccupationStagePurposeFeeRead>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: roadOccupationStagePurposeFee,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a RoadOccupationStagePurposeFee resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeCollection(requestParameters?: PostRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeCollectionRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<RoadOccupationStagePurposeFeeAppEntityRoadOccupationStagePurposeFeeRead>;
    public postRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeCollection(requestParameters?: PostRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeCollectionRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<RoadOccupationStagePurposeFeeAppEntityRoadOccupationStagePurposeFeeRead>>;
    public postRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeCollection(requestParameters?: PostRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeCollectionRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<RoadOccupationStagePurposeFeeAppEntityRoadOccupationStagePurposeFeeRead>>;
    public postRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeCollection(requestParameters?: PostRoadOccupationStagePurposeFeeRoadOccupationStagePurposeFeeCollectionRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const roadOccupationStagePurposeFee = requestParameters?.roadOccupationStagePurposeFee;

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/ld+json',
            'text/html',
            'application/octet-stream'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road_occupation_stage_purpose_fees`;
        return this.httpClient.request<RoadOccupationStagePurposeFeeAppEntityRoadOccupationStagePurposeFeeRead>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: roadOccupationStagePurposeFee,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
